export default "__VITE_ASSET__BHY$q8K5__"